import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteValorDeTerrenoYConstruccion,
  getValoresDeTerrenoYConstruccion,
  patchValorDeTerrenoYConstruccion,
  postValorDeTerrenoYConstruccion,
} from 'api/catalogos/valoresDeTerrenoYConstruccion';
import toCurrency from 'utils/toCurrency';
import { toMoment } from 'utils/normalizers';

export const permissionConfig = {
  permissionModel: 'valordeterrenoyconstruccion',
};

// eslint-disable-next-line react/prop-types
const ValoresDeTerrenoYConstruccion = ({ permission }) => (
  <PlainCRUD
    title="Valores De Terreno Y Construcción"
    permission={permission}
    get={getValoresDeTerrenoYConstruccion}
    post={postValorDeTerrenoYConstruccion}
    patch={patchValorDeTerrenoYConstruccion}
    delete={deleteValorDeTerrenoYConstruccion}
    withoutState
    paginated
    fields={[
      {
        ...defaultFields.clave,
        disabled: true,
        required: false,
        colWidth: 120,
      },
      {
        ...defaultFields.descripcion,
        colWidth: 300,
      },
      {
        name: 'anio',
        label: 'Año',
        required: true,
        colWidth: 100,
        type: 'number',
        max: parseInt(toMoment(new Date()).format('YYYY'), 10),
      },
      {
        name: 'matriz_valor',
        label: 'Matríz Bloque',
        required: true,
        colWidth: 150,
      },
      {
        name: 'tipo_bloque',
        label: 'Tipo Bloque',
        required: true,
        colWidth: 150,
        render: (tipo_bloque) => (tipo_bloque ? 'Terreno' : 'Construcción'),
        type: 'select',
        trueFalse: ['Terreno', 'Construcción'],
      },
      {
        name: 'valor',
        label: 'Valor',
        required: true,
        colWidth: 150,
        type: 'decimal',
        precision: 3,
        render: (val) => toCurrency(val, false, 3),
        colAlign: 'right',
      },
    ]}
  />
);

export default ValoresDeTerrenoYConstruccion;
